import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  footer: {
    background: theme.palette.custom.background.dark,
    marginTop: 'auto',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },
  logo: {
    height: 100,
    width: 107,
  },
  box: {
    ...dFlex('space-between', 'center'),
    paddingBottom: 40,
    paddingTop: 40,
    position: 'relative',
    zIndex: 1,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
      flexDirection: 'column',
      padding: '24px 40px !important',
      gap: 16,
    },
  },
  right: {
    ...dFlex('space-between', 'flex-end'),
    flexDirection: 'column',
    gap: '16px',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  left: {
    maxWidth: 536,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
      textAlign: 'center',
    },
  },
  footerSocials: {
    ...dFlex('flex-end', 'center'),
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
    },
  },
  icon: {
    svg: {
      path: {
        fill: theme.palette.custom.elements.accent,
      },
    },
  },
  link: {
    ...dFlex('center', 'center'),
    gap: '4px',

    svg: {
      color: theme.palette.custom.text.dark,
    },
  },
  textWrap: {
    ...dFlex('space-between', 'center'),
    gap: '32px',

    [theme.breakpoints.down(Breakpoint.Md)]: {
      ...dFlex('center', 'center'),
      flexDirection: 'column',
      gap: '16px',
    },
  },
  textItem: {
    position: 'relative',
    '&:not(:last-child)::after': {
      content: '"|"',
      position: 'absolute',
      top: '0',
      right: '-19px',
      height: '100%',
      color: theme.palette.custom?.text?.light || '#333',
    },

    [theme.breakpoints.down(Breakpoint.Md)]: {
      '&:not(:last-child)::after': {
        display: 'none',
      },
    },
  },
}));

export default useStyles;
